// extracted by mini-css-extract-plugin
export default {"wrapper":"o2-z","message":"p2-z","image":"q2-z"};